<!-- eslint-disable no-comments/disallowComments -->
<div
  class="timepicker-v2-container"
  #zuumTimePicker
  [attr.aria-labelledby]="formField?.getLabelId()"
  [class.readonly]="readonly"
  [class.dark-theme]="(_currentThemeSubject | async) === 'dark'"
>
  <form
    [formGroup]="timeGroup"
    class="time-input"
    (submit)="$event.preventDefault(); (false)"
    [class.dark-theme]="(_currentThemeSubject | async) === 'dark'"
  >
    <input
      [class.dark-theme]="(_currentThemeSubject | async) === 'dark'"
      [class.light-theme]="(_currentThemeSubject | async) === 'light'"
      (paste)="onPasteClipboard($event)"
      #timeInput
      [disabled]="disabled"
      autocomplete="off"
      class="time-cell t-body-text-regular"
      formControlName="time"
      readonly
      type="text"
      name="fb-time"
      id="fb_time"
      (blur)="onResetFirstClick()"
      (click)="onFocusAndSelect()"
    />
    <div
      class="fb-time-input-buttons"
      *ngIf="!disabled"
      [ngStyle]="{ 'min-width': apmMode ? '240px' : '' }"
      [class.dark-theme-bg-color]="(_currentThemeSubject | async) === 'dark'"
      [class.dark-theme]="(_currentThemeSubject | async) === 'dark'"
      [ngClass]="xAnchor"
    >
      <div class="inputs-wrapper">
        <form [formGroup]="manualTimeInputGroup" class="time-input-inner" (submit)="$event.preventDefault(); (false)">
          <input
            #fb_hoursInput
            [disabled]="disabled"
            autocomplete="off"
            class="time-cell-inner t-body-text-regular"
            [mask]="borderlessMode ? (threeNumbersMask ? '0000' : '00') : 'Hh'"
            [dropSpecialCharacters]="false"
            [leadZeroDateTime]="true"
            formControlName="hours"
            type="text"
            name="fb-hours"
            (blur)="updateValueInMainInput()"
            (click)="selectSubInput('fb_hoursInput')"
          />
          <input
            #fb_minutesInput
            [disabled]="disabled"
            autocomplete="off"
            class="time-cell-inner t-body-text-regular"
            [mask]="'m0'"
            [dropSpecialCharacters]="false"
            [leadZeroDateTime]="true"
            formControlName="minutes"
            type="text"
            name="fb-minutes"
            (blur)="updateValueInMainInput()"
            (click)="selectSubInput('fb_minutesInput')"
          />
          <input
            #fb_secondsInput
            [disabled]="disabled"
            autocomplete="off"
            class="time-cell-inner t-body-text-regular"
            [mask]="'s0'"
            [dropSpecialCharacters]="false"
            [leadZeroDateTime]="true"
            formControlName="seconds"
            type="text"
            name="fb-seconds"
            (blur)="updateValueInMainInput()"
            (click)="selectSubInput('fb_secondsInput')"
          />
          <input
            *ngIf="apmMode"
            #fb_apm
            [disabled]="disabled"
            autocomplete="off"
            class="time-cell-inner t-body-text-regular"
            [mask]="'SS'"
            [dropSpecialCharacters]="false"
            [leadZeroDateTime]="true"
            formControlName="apm"
            type="text"
            name="fb-apm"
            (blur)="updateValueInMainInput()"
            (click)="selectSubInput('fb_apm')"
          />
        </form>
      </div>
      <div class="buttons-wrapper">
        <div class="fb-hours-buttons">
          <button (click)="onUpdateValue('hours', false)"><mat-icon>arrow_left</mat-icon></button>
          <button (click)="onUpdateValue('hours', true)"><mat-icon>arrow_right</mat-icon></button>
        </div>
        <div class="fb-minutes-buttons">
          <button (click)="onUpdateValue('minutes', false)"><mat-icon>arrow_left</mat-icon></button>
          <button (click)="onUpdateValue('minutes', true)"><mat-icon>arrow_right</mat-icon></button>
        </div>
        <div class="fb-seconds-buttons">
          <button (click)="onUpdateValue('seconds', false)"><mat-icon>arrow_left</mat-icon></button>
          <button (click)="onUpdateValue('seconds', true)"><mat-icon>arrow_right</mat-icon></button>
        </div>
        <div class="fb-seconds-buttons" *ngIf="apmMode">
          <button (click)="toggleApm()"><mat-icon>arrow_left</mat-icon></button>
          <button (click)="toggleApm()"><mat-icon>arrow_right</mat-icon></button>
        </div>
      </div>
    </div>
  </form>
</div>
